<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">{{ label }}</label>
    <div class="flex items-center gap-4">
      <img v-if="modelValue" :src="modelValue" class="h-16 max-w-32 rounded-lg object-contain border border-gray-200" />
      <div v-else class="w-16 h-16 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center">
        <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
      </div>
      <div class="flex-1">
        <input type="file" accept="image/*" @change="upload" ref="fileInput" class="hidden" />
        <button type="button" @click="$refs.fileInput.click()" :disabled="uploading"
                class="px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition">
          {{ uploading ? '...' : (modelValue ? changeText : uploadText) }}
        </button>
        <button v-if="modelValue" type="button" @click="$emit('update:modelValue', '')"
                class="ml-2 px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition">
          {{ removeText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  modelValue: String,
  label: { type: String, default: 'Logo' },
  uploadText: { type: String, default: 'Upload' },
  changeText: { type: String, default: 'Change' },
  removeText: { type: String, default: 'Remove' },
  csrfToken: String,
  uploadType: { type: String, default: 'general' }
})

const emit = defineEmits(['update:modelValue'])
const uploading = ref(false)

async function upload(e) {
  const file = e.target.files[0]
  if (!file) return

  uploading.value = true
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', props.uploadType)

  try {
    const res = await fetch('/upload', {
      method: 'POST',
      headers: { 'X-CSRF-Token': props.csrfToken },
      body: formData
    })
    if (res.ok) {
      const data = await res.json()
      emit('update:modelValue', data.url)
    }
  } catch {}
  uploading.value = false
}
</script>
